import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Guard for the /devtool route.
 * Allows access ONLY when:
 * 1. isDevToolEnabled is true (dev environment only)
 * 2. Window is opened as a popup (has window.opener)
 * Otherwise redirects to sign-in.
 */
export const devtoolGuard: CanActivateFn = () => {
  if (environment.isDevToolEnabled && window.opener) {
    return true;
  }
  const router = inject(Router);
  return router.parseUrl('/sign-in');
};
